import { render, staticRenderFns } from "./BatchUpdate.vue?vue&type=template&id=0ad143d4&lang=pug"
import script from "./BatchUpdate.vue?vue&type=script&lang=ts"
export * from "./BatchUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports